import React from 'react'

import { Field } from 'formik'

import { ZariContext } from '_zari/context'

import { Form, Col } from '_zari/core'

import { TiposTablaPersonalizadaConstant } from 'constants/index'

import * as TablaPersonalizadaService from 'services/tablasPersonalizadas.service'

const PlacaFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const __zariContext = React.useContext(ZariContext)
  const [placas, setPlacas] = React.useState([])

  React.useEffect(() => {
    TablaPersonalizadaService.getAsSelect(TiposTablaPersonalizadaConstant.PLACA)
      .then(({ data }) => setPlacas(data))
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext])

  return (
    <Form.Group>
      <Form.Label text='PLACA' htmlFor='select-_idPlaca' md={3} alignRightAt='md' />
      <Col md={9}>
        <Field name='_idPlaca'>
          {({ field }) => (
            <Form.Select {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='select-_idPlaca'>
              <option value=''>Seleccionar</option>
              {placas.map((val, key) => (
                <option key={key} value={val._id}>
                  {val.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(PlacaFormGroup)
